import React, { useState ,useEffect, createContext} from 'react';
import { Grid, Typography } from '@mui/material';
import { CommonButton, CommonOutlinedButton, CustomTextFeildForHallContract } from '../../common/StyledComponents/StyledFields';
import styles from "./formTwo.module.scss"
import FacilityUsageAgreementAcknowledgement from '../formFour/formFour';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormFooter from '../formFooter';
import { apiRequest, catchErrorMessageHandler, getUserSelectedRole } from '../../../infrastructure/backendService';
import toast from 'react-hot-toast';
import ErrorPopup from '../../common/ErrorPopup';
import apiPath from '../../../config/apiPaths.json';
import constants from "../../../config/constants.json";
import { useSearchParams } from "react-router-dom";
import { hallRentalListProps } from '../../../infrastructure/GlobalContextProvider';
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import { find, forEach } from 'lodash';

interface fromTwoProps {
  updateParentState: (newState: boolean) => void;
  formData: any;
  sign: string;
  handleInputChange: any;
  hallList:any
}

// Define the interface for context value
interface MyContextValue {
  tableEventFormData: {
    facilityTitle: string;
    eventDate: string;
    eventTime: {
      fromTime: string;
      toTime: string;
    };
    totalHours: string;
    amountPerHours: number;
    amountTotal: number;
  }[];
}

// Create a context with the defined interface
export const MyContext = createContext<MyContextValue>({
  tableEventFormData: [
    {
      facilityTitle: '',
      eventDate: '',
      eventTime: {
        fromTime: '',
        toTime: '',
      },
      totalHours: '',
      amountPerHours: 0,
      amountTotal: 0,
    },
  ],
});

const FacilityAggrementTable = (props: fromTwoProps) => {
  const [searchParam] = useSearchParams();
const hallName = searchParam.get("hallName") || "";
const amount = searchParam.get("amount") || "";
  const [nextStep, setNextStep] = useState(false);
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(getUserSelectedRole() || "")
  const eventDate = searchParam.get("eventDate") || "";
  const [tableFormData, setTableFormData] = useState([
    {
      facilityTitle: '',
      setupDate: '',
      setupTime: {
        fromTime: '',
        toTime: '',
      },
      totalHours: '',
      amountPerHours: 0,
      amountTotal: 0,
    },
  ]);
  const [tableEventFormData, setTableEventFormData] = useState([
    {
      facilityTitle: '',
      eventDate: '',
      eventTime: {
        fromTime: '',
        toTime: '',
      },
      totalHours: '',
      amountPerHours: 0,
      amountTotal: 0,
    },
  ]);
  const hallId = searchParam.get("hallId") || "";
  const [eventTotalAmount, setEventTotalAmount] = useState(0);

  useEffect(() => {
    const totalAmount = tableEventFormData.reduce((acc, currentValue) => {
      const amountValue = Number(currentValue.amountTotal) || 0;

      // Calculate the amount for the current event and add to the accumulator
      return acc + (amountValue);
    }, 0);

    // Update the state with the new total amount
    setEventTotalAmount(totalAmount);
  }, [tableEventFormData]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.hallRentalList,
      includeToken: true,
    })
      .then((res) => {
        if(props?.formData?.contractForm?.eventHallId){
          const hallIds = props.formData.contractForm.eventHallId;
          let tableEvent: any[] = [];
          forEach(hallIds, (hid, index) => {
            const hallData = find(res.data, {id: hid});
            let hoursCal = props.formData.duration - hallData.minimumHours;
            // const hallData = res.data.find((hall:hallRentalListProps) => hall.id.toString() === id);
            tableEvent.push({
              ...tableEventFormData[0],
              facilityTitle: hallData.name || "",
            eventDate: eventDate || "",
            eventTime: {
              fromTime: props.formData.bookingTime,
              toTime:
                  calculateEndTime(
                    props.formData.bookingTime,
                    props.formData.contractForm.eventDuration
                  ) || "",
            },
            totalHours: props.formData.contractForm.eventDuration || "",
              amountPerHours: hallData.hourlyFee,
              amountTotal:
                parseInt(
                  hallData.minimumFee +
                    hallData.securityDeposit +
                    hallData.setupAndCleaning +
                    hoursCal * hallData.hourlyFee
              ) || 0,
            });
          });
          setTableEventFormData(tableEvent);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={false}
          />
        );
      });
  }, []);

  const handleClick = () => {
    props.updateParentState(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const updatedState = (newState: boolean) => {
    setNextStep(newState);
  }

  let hallBookingId=13;
  let contractId=7;

  const [getres,setGetres]=useState(null);
  




  function calculateEndTime(startTime:any, eventDuration:any) {
    const [startHour, startMinute, meridiem] = startTime.split(/:| /);
    let endHour = parseInt(startHour);
    let endMeridiem = meridiem;
    endHour += eventDuration;
    if (endHour >= 12) {
        if (endHour > 12) {
            endHour -= 12;
        }
        endMeridiem = meridiem === 'AM' ? 'PM' : 'AM';
    }
    const paddedHour = String(endHour).padStart(2, '0');
    const endTime = `${paddedHour}:${startMinute} ${endMeridiem}`;
    return endTime;
}



let PatchReq = JSON.parse(`{
  "eventDuration": 0,
  "eventGuestCount": 0,
  "eventHalls": [
    {
      "id": 0,
      "name": "string",
      "minimumFee": 0,
      "hourlyFee": 0,
      "setupAndCleaning": 0,
      "securityDeposit": 0,
      "eventDate": "2024-03-04T07:29:37.570Z",
      "eventDuration": 0,
      "eventStartTime": "2024-03-04T07:29:37.570Z",
      "eventEndTime": "2024-03-04T07:29:37.570Z"
    }
  ],
  "facilityUsageReservationFee": 0,
  "furnitureSetupBreakdownCleaningFee": 0,
  "securityDeposit": 0,
  "initialAmountToPay": 0,
  "finalAmountToPay": 0,
  "managerUsername": "string",
  "managerFullname": "string",
  "managerPhoneNumber": "string",
  "managerAcknowledgedAuthorityToSign": true,
  "managerAcknowledgedAuthorityToSignDate": "2024-03-04T07:29:37.570Z"
}`);
const [patchReq,setPatchReq]=useState({...PatchReq})



  // useEffect(() => {

  //   apiRequest({
  //     method: "GET",
  //     endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${hallBookingId}/contracts/${contractId}`,
  //     includeToken: true,
  //   })
  //     .then((res) => {
  //       //console.log(res.data, "first...............");
  //       const timestamp = res.data?.eventDate;
  //       const dateObject = new Date(timestamp);
  //       const month = String(dateObject.getMonth() + 1).padStart(2, '0');
  //       const day = String(dateObject.getDate()).padStart(2, '0');
  //       const year = dateObject.getFullYear();

  //       const formattedDate = `${month}/${day}/${year}`;
  //       console.log(props.formData)
  //       setTableEventFormData([
  //         {
  //           facilityTitle: hallName || '',
  //           eventDate: eventDate || '',
  //           eventTime: {
  //             fromTime: props.formData.bookingTime,
  //             toTime: calculateEndTime(props.formData.bookingTime, props.formData.contractForm.eventDuration) || "",
  //           },
  //           totalHours: props.formData.contractForm.eventDuration || "",
  //           amountTotal: parseInt(amount) || 0,
  //         } as any,,
  //       ]);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       toast.custom(
  //         <ErrorPopup
  //           showMessage={catchErrorMessageHandler(err)}
  //           isOpen={false}
  //         />
  //       );
  //     });
  // }
  //   , []);

  const addRow = () => {
    setTableFormData([...tableFormData, {
      facilityTitle: '',
      setupDate: '',
      setupTime: {
        fromTime: '',
        toTime: '',
      },
      totalHours: '',
      amountPerHours: 0,
      amountTotal: 0,
    }]);
  };

  const addEventRow = () => {
    setTableEventFormData([...tableEventFormData, {
      facilityTitle: '',
      eventDate: '',
      eventTime: {
        fromTime: '',
        toTime: '',
      },
      totalHours: '',
      amountPerHours: 0,
      amountTotal: 0,
    }]);
  };

  const deleteRow = (index:number) => {
    const updatedFormData = [...tableFormData];
    updatedFormData.splice(index, 1); // Remove the row
    setTableFormData(updatedFormData);
  };
  
  const deleteEventRow = (index:number) => {
    const updatedEventFormData = [...tableEventFormData];
    updatedEventFormData.splice(index, 1); // Remove the row
    setTableEventFormData(updatedEventFormData);
  };

  const handleFieldChange = (index: any, field: any, value: any) => {
    const updatedFormData = [...tableFormData];
    const updatedEventFormData = [...tableEventFormData];
    updatedFormData[index] = {
      ...updatedFormData[index],
      [field]: value,
    };
    updatedEventFormData[index] = {
      ...updatedEventFormData[index],
      [field]: value,
    };
    setTableFormData(updatedFormData);
    setTableEventFormData(updatedEventFormData);
  };

  const calculateTotal = () => {
    return (
      <>
        Total Amount
      </>
    )
  };

  

  const tableComponentOne = () => {
    return (
      <Grid>
        <table className={styles.tableContainer}>
          <thead>
            <tr>
              <th rowSpan={2}>Facility Title</th>
              <th rowSpan={2}>Setup Date</th>
              <th colSpan={2}>Setup Time</th>
              <th rowSpan={2}>Total Hours</th>
              <th rowSpan={2}>$/hrs</th>
              <th rowSpan={2}>Total $</th>
            </tr>
            <tr>
              <th rowSpan={2}>From Time</th>
              <th rowSpan={2}>To Time</th>
            </tr>
          </thead>
          <tbody>
            {tableFormData.map((item, index) => (
              <tr key={index}>
                <td>{item.facilityTitle}</td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.setupDate}
                    onChange={(e) => handleFieldChange(index, 'setupDate', e.target.value)}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.setupTime.fromTime}
                    onChange={(e) => handleFieldChange(index, 'setupTime', { ...item.setupTime, fromTime: e.target.value })}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.setupTime.toTime}
                    onChange={(e) => handleFieldChange(index, 'setupTime', { ...item.setupTime, toTime: e.target.value })}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.totalHours}
                    onChange={(e) => handleFieldChange(index, 'totalHours', e.target.value)}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.amountPerHours}
                    onChange={(e) => handleFieldChange(index, 'amountPerHours', e.target.value)}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.amountTotal}
                    onChange={(e) => handleFieldChange(index, 'amountTotal', e.target.value)}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                {tableFormData.length > 1 && (
                  <td>
                    <img
                      src={deleteIcon}
                      onClick={() => deleteRow(index)}
                    />
                  </td> 
                )}
              </tr>
            ))}
            <tr>
              <td>Total</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <CustomTextFeildForHallContract
                  fullWidth
                  required
                  inputProps={{
                    readOnly: !hasManagerLevelRole,
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
    );
  }

  const tableComponentTwo = () => {
    return (
      <Grid>
        <table className={styles.tableContainer}>
          <thead>
            <tr>
              <th rowSpan={2}>Facility Title</th>
              <th rowSpan={2}>Event Date</th>
              <th colSpan={2}>Event Time</th>
              <th rowSpan={2}>Total Hours</th>
              <th rowSpan={2}>$/hrs</th>
              <th rowSpan={2}>Total $</th>
            </tr>
            <tr>
              <th rowSpan={2}>From Time</th>
              <th rowSpan={2}>To Time</th>
            </tr>
          </thead>
          <tbody>
            {tableEventFormData.map((item, index) => (
              <tr key={index}>
                <td>{item.facilityTitle}</td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.eventDate}
                    onChange={(e) =>
                      handleFieldChange(index, "setupDate", e.target.value)
                    }
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.eventTime.fromTime}
                    onChange={(e) => handleFieldChange(index, 'setupTime', { ...item.eventTime, fromTime: e.target.value })}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.eventTime.toTime}
                    onChange={(e) => handleFieldChange(index, 'setupTime', { ...item.eventTime, toTime: e.target.value })}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.totalHours}
                    onChange={(e) => handleFieldChange(index, 'totalHours', e.target.value)}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.amountPerHours}
                    onChange={(e) => handleFieldChange(index, 'amountPerHours', e.target.value)}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                <td>
                  <CustomTextFeildForHallContract
                    fullWidth
                    required
                    value={item.amountTotal}
                    onChange={(e) => handleFieldChange(index, 'amountTotal', e.target.value)}
                    inputProps={{
                      readOnly: !hasManagerLevelRole,
                    }}
                  />
                </td>
                {/* {tableEventFormData.length > 1 && (
                  <td>
                    <img
                      src={deleteIcon}
                      onClick={() => deleteEventRow(index)}
                    />
                  </td>
                )} */}
              </tr>
            ))}
            <tr>
              <td>Total</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <CustomTextFeildForHallContract
                  fullWidth
                  required
                  inputProps={{
                    readOnly: !hasManagerLevelRole,
                  }}
                  value={eventTotalAmount}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
    )
  }
  // const apiCall = (updatedPatchReq:any) => {
  //   //tableEventFormData
  //   // setPatchReq((prev:any)=>({...prev,
    
  //   // }))
  //   console.log(updatedPatchReq,"patchReq");
  //   apiRequest({
  //     method: "PATCH",
  //     endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${hallBookingId}/contracts/${contractId}/facilityUsageFee`,
  //     includeToken: true,
  //     body: JSON.stringify(updatedPatchReq)
  //   })
  //     .then((res) => {
  //       console.log(res.data, "res");
  //       const successMessage = "Fee details changed successfully";
  //       alert(successMessage);
  //   setNextStep(true);
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  // };
  // const handlePatchClick=()=>{
  //   if(hasManagerLevelRole) {
  //     const updatedPatchReq = {
  //       ...patchReq,
  //       eventDuration: 0,
  //       eventHalls: tableEventFormData.map((item) => ({
  //         ...item,
  //         id: 0,
  //         name: item.facilityTitle,
  //         minimumFee: 0,
  //         hourlyFee: 0,
  //         setupAndCleaning: 0,
  //         securityDeposit: 0,
  //         eventDate: item.eventDate,
  //         eventDuration: item.totalHours,
  //         eventStartTime: item.eventTime.fromTime,
  //         eventEndTime: item.eventTime.toTime,
  //         // Assuming your state structure matches your API expectations
  //         // You might need to adjust based on the actual API requirements
  //       })),
  //     };
      
  //     setPatchReq(updatedPatchReq);
  //     apiCall(updatedPatchReq);
  //   } else {
  //     setNextStep(true);
  //   }
    
  // }
  // const apiCall = (updatedPatchReq:any) => {
  //   //tableEventFormData
  //   // setPatchReq((prev:any)=>({...prev,
    
  //   // }))
  //   console.log(updatedPatchReq,"patchReq");
  //   apiRequest({
  //     method: "PATCH",
  //     endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${hallBookingId}/contracts/${contractId}/facilityUsageFee`,
  //     includeToken: true,
  //     body: JSON.stringify(updatedPatchReq)
  //   })
  //     .then((res) => {
  //       console.log(res.data, "res");
  //       const successMessage = "Fee details changed successfully";
  //       alert(successMessage);
  //   setNextStep(true);
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  // };
  // const handlePatchClick=()=>{
  //   if(hasManagerLevelRole) {
  //     const updatedPatchReq = {
  //       ...patchReq,
  //       eventDuration: 0,
  //       eventHalls: tableEventFormData.map((item) => ({
  //         ...item,
  //         id: 0,
  //         name: item.facilityTitle,
  //         minimumFee: 0,
  //         hourlyFee: 0,
  //         setupAndCleaning: 0,
  //         securityDeposit: 0,
  //         eventDate: item.eventDate,
  //         eventDuration: item.totalHours,
  //         eventStartTime: item.eventTime.fromTime,
  //         eventEndTime: item.eventTime.toTime,
  //         // Assuming your state structure matches your API expectations
  //         // You might need to adjust based on the actual API requirements
  //       })),
  //     };
      
  //     setPatchReq(updatedPatchReq);
  //     apiCall(updatedPatchReq);
  //   } else {
  //     setNextStep(true);
  //   }
    
  // }

  const FormStepContent = () => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <span className={styles.currentNumberStyle}>3</span>{" "}
      <span className={styles.totalPagesNumberStyle}>/ 9</span>
    </div>
  );

  const navigationButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          startIcon={<ChevronLeftIcon />}
          onClick={handleClick}
        >
          Previous
        </CommonOutlinedButton>
        {FormStepContent()}
        <CommonButton
          endIcon={<KeyboardArrowRightIcon />}
          onClick={() => {
            setNextStep(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          Next
        </CommonButton>
      </div>
    );
  };

  return (
    <>
      {!nextStep && <div style={{ display: "flex", flexDirection: "column" }}>
        {/* <div style={{ display: "flex", gap: "1rem", float: "right", marginBottom: "40px", marginLeft: "auto" }}>
          {navigationButtons()}
        </div> */}
        <Grid>
          <Grid sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
            <Typography sx={{ fontSize: "18px" }}>
              The user uses the following facilities as per this agreement, for the following data and during the following hours and for the following fee detailed below.
            </Typography>
          </Grid>
          <Grid sx={{ display: "flex", flexDirection: "column" }}>
            <Grid>
              {tableComponentOne()}
            </Grid>
            {hasManagerLevelRole ? <CommonButton onClick={addRow} sx={{ width: "50px", margin: "10px 0px", float: "right", marginLeft: "auto" }}>
              Add row
            </CommonButton> : ""}
            <Grid>
              {tableComponentTwo()}
            </Grid>
            {hasManagerLevelRole ? <CommonButton onClick={addEventRow} sx={{ width: "50px", margin: "10px 0px", float: "right", marginLeft: "auto" }}>
              Add row
            </CommonButton> : ""}
          </Grid>
        </Grid>
        <FormFooter
          sign={props.sign}
          handleInputChange={props.handleInputChange}
          navigationButtons={navigationButtons()}
        />
      </div>}

      {nextStep &&<MyContext.Provider value={{tableEventFormData}}>

      <FacilityUsageAgreementAcknowledgement hallList={props.hallList} sign={props.sign} handleInputChange={props.handleInputChange} updateParentState={updatedState} formData={props.formData} />
      </MyContext.Provider>
      }
    </>
  );
};

export default FacilityAggrementTable;
